<template>
<v-container grid-list-xl fluid class="declaration-list-container">
    <v-layout row wrap>
        <v-flex lg12>
            <v-card class="elevation-1 rounded-xl overflow-hidden border border-slate-200 shadow-lg">
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                
                <!-- Filter Stats Bar -->
                <div class="bg-slate-50 border-b border-slate-200 p-4 flex flex-col gap-4">
                  <!-- Row 1: Filters & Selection -->
                  <div class="flex flex-wrap items-center">
                    <span class="font-semibold text-slate-500 text-base mr-3 ml-3">Bộ lọc nhanh:</span>
                    <button type="button" 
                      @click="setQuickStatusFilter('all')" 
                      :class="selectedStatusFilter === 'all' ? 'bg-slate-300 active-tab' : 'bg-slate-200 hover:bg-slate-300'"
                      class="px-3.5 py-1.5 rounded-full font-medium text-slate-700 transition-all flex items-center gap-2 text-base border border-transparent mr-4"
                      style="margin-right: 16px;"
                    >
                      Tất cả <span class="bg-slate-400 text-white text-xs px-2 py-0.5 rounded-full font-bold">{{ totalOrdersCount }}</span>
                    </button>
                    <button type="button" 
                      @click="setQuickStatusFilter('da_nhap_kho_tq')" 
                      :class="selectedStatusFilter === 'da_nhap_kho_tq' ? 'bg-amber-200' : 'bg-amber-50 hover:bg-amber-100'"
                      class="px-3.5 py-1.5 rounded-full font-medium text-amber-700 border border-amber-200 transition-all flex items-center gap-2 text-base mr-4"
                      style="margin-right: 16px;"
                    >
                      Đã nhập kho TQ <span class="bg-amber-500 text-white text-xs px-2 py-0.5 rounded-full font-bold">{{ storeTqOrdersCount }}</span>
                    </button>
                    <button type="button" 
                      @click="setQuickStatusFilter('da_nhap_kho_vn')" 
                      :class="selectedStatusFilter === 'da_nhap_kho_vn' ? 'bg-emerald-200' : 'bg-emerald-50 hover:bg-emerald-100'"
                      class="px-3.5 py-1.5 rounded-full font-medium text-emerald-700 border border-emerald-200 transition-all flex items-center gap-2 text-base mr-4"
                      style="margin-right: 16px;"
                    >
                      Đã nhập kho VN <span class="bg-emerald-500 text-white text-xs px-2 py-0.5 rounded-full font-bold">{{ storeVnOrdersCount }}</span>
                    </button>
                    <button type="button" 
                      @click="setQuickStatusFilter('other')" 
                      :class="selectedStatusFilter === 'other' ? 'bg-indigo-200' : 'bg-indigo-50 hover:bg-indigo-100'"
                      class="px-3.5 py-1.5 rounded-full font-medium text-indigo-700 border border-indigo-200 transition-all flex items-center gap-2 text-base"
                    >
                      Đơn khác <span class="bg-amber-500 text-xs px-2 py-0.5 rounded-full font-bold">{{ otherOrdersCount }}</span>
                    </button>
                    <div style="margin-left: auto;" class="pr-3 flex items-center">
                      <button
                        type="button"
                        class="px-3.5 py-2 rounded-lg font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-100 transition-colors text-base shadow-sm mr-4"
                        style="margin-right: 16px;"
                        @click="toggleCurrentPageSelection"
                      >
                        {{ isAllCurrentPageSelected ? 'Bỏ chọn trang hiện tại' : 'Chọn trang hiện tại' }}
                      </button>
                      <div class="flex items-center gap-2.5 px-3 py-2 mr-3 rounded-lg bg-white border border-slate-300 shadow-sm">
                        <span class="text-base font-semibold text-slate-500 mr-2">Đã chọn: {{ selectedOrderIds.length }} đơn</span>
                        <select
                          v-model="selectedDeclarationSendFilter"
                          @change="onDeclarationSendFilterChange"
                          class="declaration-filter-select text-base font-semibold text-slate-700"
                        >
                          <option value="all">Tất cả khai báo</option>
                          <option value="sent">Đã gửi khai báo</option>
                          <option value="not_sent">Chưa gửi khai báo</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Sub Row: Quick Sub-Filters for TQ & VN -->
                  <div v-if="selectedStatusFilter === 'da_nhap_kho_tq'" class="flex flex-wrap items-center pl-3 pt-2.5 border-t border-slate-200/80 ml-3">
                    <span class="font-semibold text-slate-600 text-base mr-3">Trạng thái khai báo:</span>
                    <label
                      v-for="st in declaration_status_list"
                      :key="st.value"
                      class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-base font-medium cursor-pointer border transition-all select-none mr-3 mb-1"
                      :class="selectedDecStatuses.includes(st.value) ? 'bg-amber-100 border-amber-400 text-amber-900 shadow-sm' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'"
                      style="margin-right: 12px; margin-bottom: 4px;"
                    >
                      <input
                        type="checkbox"
                        :value="st.value"
                        v-model="selectedDecStatuses"
                        @change="onSubFilterChange"
                        class="rounded text-amber-600 focus:ring-amber-500 h-3.5 w-3.5"
                      />
                      <span class="w-2 h-2 rounded-full" :style="{ backgroundColor: st.color }"></span>
                      {{ st.name }}
                    </label>
                  </div>

                  <div v-if="selectedStatusFilter === 'da_nhap_kho_vn'" class="flex flex-wrap items-center pl-3 pt-2.5 border-t border-slate-200/80 ml-3">
                    <span class="font-semibold text-slate-600 text-base mr-3">Tình trạng hóa đơn:</span>
                    <label
                      v-for="invOpt in subInvoiceStatusOptions"
                      :key="invOpt.key"
                      class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-base font-medium cursor-pointer border transition-all select-none mr-3 mb-1"
                      :class="selectedInvoiceStatuses.includes(invOpt.key) ? 'bg-emerald-100 border-emerald-400 text-emerald-900 shadow-sm' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'"
                      style="margin-right: 12px; margin-bottom: 4px;"
                    >
                      <input
                        type="checkbox"
                        :value="invOpt.key"
                        v-model="selectedInvoiceStatuses"
                        @change="onSubFilterChange"
                        class="rounded text-emerald-600 focus:ring-emerald-500 h-3.5 w-3.5"
                      />
                      {{ invOpt.label }}
                    </label>
                  </div>

                  <!-- Row 2: Actions -->
                  <div class="flex justify-end pr-3 mr-3">
                    <button
                      type="button"
                      class="action-btn px-3.5 py-2 rounded-lg font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-100 transition-colors flex items-center gap-2 text-base shadow-sm mr-3"
                      style="margin-right: 14px;"
                      :disabled="!canUpdateVehicle"
                      @click="openUpdateVehicleDialog"
                    >
                      <i class="fas fa-truck-moving text-blue-600"></i>
                      Cập nhật xe
                    </button>
                    <button
                      type="button"
                      class="action-btn px-3.5 py-2 rounded-lg font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-100 transition-colors flex items-center gap-2 text-base shadow-sm mr-3"
                      style="margin-right: 14px;"
                      :disabled="!canCreateVehicle"
                      @click="openCreateVehicleDialog"
                    >
                      <i class="fas fa-truck-loading text-amber-600"></i>
                      Tạo xe hàng
                    </button>
                    <button
                      type="button"
                      class="action-btn px-3.5 py-2 rounded-lg font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-100 transition-colors flex items-center gap-2 text-base shadow-sm"
                      :disabled="declarationExcelLoading"
                      @click="exportDeclarationExcel"
                      >
                        <i class="fas fa-file-excel text-emerald-600"></i>
                        {{ declarationExcelLoading ? 'Đang xuất file...' : 'Xuất file khai báo' }}
                    </button>
                  </div>
                </div>

                <v-data-table :headers="displayTableHeaders" :items="filteredGroupedOrders" :must-sort="true" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :loading="loading" :mobile-breakpoint="100" class="main-declaration-table">
                    <template v-slot:item="{ item, index }">
                        <tr class="order-summary-row">
                            <td :colspan="displayTableHeaders.length" class="py-3 px-4">
                              <div class="order-summary-bar">
                                <span class="order-summary-text">KH: <strong>{{ item.Username }}</strong></span>
                                <span class="order-summary-text">MH: {{ getStaffNameById(item.OrderBuyerID) }}</span>
                                <span class="order-summary-text">CS: {{ getStaffNameById(item.OrderCustomerServiceID) }}</span>
                                <span class="order-summary-text">S: {{ getStaffNameById(item.OrderSalerID) }}</span>
                                <span class="order-summary-text">NK: {{ getStaffNameById(item.OrderXNKID) }}</span>
                                <span class="order-summary-text">Tổng tiền: <strong>{{ item.OrderTotalAmountVND | currency }} đ</strong></span>
                                <span class="order-summary-text">Đã cọc: <strong class="order-summary-value--paid">{{ item.OrderDeposit | currency }} đ</strong></span>
                                <span class="order-summary-text">Tiền thiếu: <strong class="order-summary-value--remain">{{ item.OrderRemainAmount | currency }} đ</strong></span>
                              </div>
                            </td>
                        </tr>
                        <tr class="align-top hover:bg-slate-50/50 transition-colors duration-150">
                            <td class="py-4 px-2 text-center col-select">
                              <input
                                type="checkbox"
                                class="order-select-checkbox"
                                :checked="isOrderSelected(item.OrderID)"
                                @change="toggleOrderSelection(item.OrderID, $event.target.checked)"
                              />
                            </td>
                            <!-- 1. # -->
                            <td class="py-4 px-3 text-center font-semibold text-slate-500 col-seq">
                              {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
                            </td>
                            
                            <!-- 2. Đơn hàng -->
                            <td class="py-4 px-4 col-order">
                              <a @click.stop="gotoOrderDetail(item.OrderID)" class="text-base font-bold text-red-600 block mb-1 order-code-link">MD{{ item.OrderID }}</a>
                              <span v-if="item.OrderStatus !== undefined" class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-sm font-semibold" :style="getOrderStatusStyle(item.OrderStatus)">
                                <span class="w-1.5 h-1.5 rounded-full mr-1 bg-red-600" :style="{ backgroundColor: getOrderStatusColor(item.OrderStatus) }"></span>
                                {{ getOrderStatusName(item.OrderStatus) }}
                              </span>
                              <div class="order-extra-info mt-2">
                                <div v-if="Number(item.OrderTotalInvoicePrice) > 0" class="order-extra-row">
                                  <span class="order-extra-label">Tổng hóa đơn</span>
                                  <span class="order-extra-value">{{ item.OrderTotalInvoicePrice | currency }}</span>
                                </div>
                                <div v-if="Number(item.OrderTaxNKAmount) > 0 || Number(item.OrderTaxNKRate) > 0" class="order-extra-row">
                                  <span class="order-extra-label">Thuế NK</span>
                                  <span class="order-extra-value">{{ formatRateAmount(item.OrderTaxNKRate, item.OrderTaxNKAmount) }}</span>
                                </div>
                                <div v-if="Number(item.OrderTaxVATAmount) > 0 || Number(item.OrderTaxVATRate) > 0" class="order-extra-row">
                                  <span class="order-extra-label">Thuế VAT</span>
                                  <span class="order-extra-value">{{ formatRateAmount(item.OrderTaxVATRate, item.OrderTaxVATAmount) }}</span>
                                </div>
                                <div v-if="Number(item.OrderTaxOtherAmount) > 0 || Number(item.OrderTaxOtherRate) > 0" class="order-extra-row">
                                  <span class="order-extra-label">Thuế khác</span>
                                  <span class="order-extra-value">{{ formatRateAmount(item.OrderTaxOtherRate, item.OrderTaxOtherAmount) }}</span>
                                </div>
                                <div v-if="Number(item.OrderSurcharge1Amount) > 0 || Number(item.OrderSurcharge1Rate) > 0" class="order-extra-row">
                                  <span class="order-extra-label">Phụ phí 1</span>
                                  <span class="order-extra-value">{{ formatRateAmount(item.OrderSurcharge1Rate, item.OrderSurcharge1Amount) }}</span>
                                </div>
                                <div v-if="Number(item.OrderSurcharge2Amount) > 0 || Number(item.OrderSurcharge2Rate) > 0" class="order-extra-row">
                                  <span class="order-extra-label">Phụ phí 2</span>
                                  <span class="order-extra-value">{{ formatRateAmount(item.OrderSurcharge2Rate, item.OrderSurcharge2Amount) }}</span>
                                </div>
                              </div>
                            </td>
                            
                            <!-- 3. Chi tiết hàng hóa viết hóa đơn -->
                            <td class="py-4 px-4 col-details">
                              <div class="col-md-12 pa-0 overflow-x-auto">
                                <table class="sub-declaration-table shadow-sm rounded overflow-hidden" style="border-collapse: collapse; width: 100%;">
                                  <tbody>
                                    <tr class="sub-table-header text-white font-medium text-sm">
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 6px; text-align: center; width: 120px;">Mã khai báo</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: center; width: 80px;">Hình ảnh</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 8px; text-align: left; width: 250px;">Tên SP, hàng hóa</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: center; width: 65px;">Đv tính</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 6px; text-align: right; width: 115px;">Đơn giá dự kiến</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: center; width: 75px;">Số lượng</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: right; width: 100px;">Thuế XNK (%)</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: right; width: 100px;">Thuế VAT (%)</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: center; width: 135px;">
                                        <div>Mã HS</div>
                                        <div style="font-size: 11px; font-weight: normal; opacity: 0.85;">Nhà nhập khẩu</div>
                                      </th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 6px; text-align: center; width: 115px;">Trạng thái</th>
                                      <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 6px; text-align: left; width: 160px;">Ghi chú</th>
                                    </tr>
                                    <tr v-for="(dec, dIdx) in item.declarations" :key="dec.ID" :class="dIdx % 2 === 0 ? 'bg-white' : 'bg-slate-50-50'" class="sub-table-row">
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;">
                                        <a @click.stop="gotoDetail(dec.ID)" style="cursor: pointer" class="text-blue-600 hover:text-blue-800 hover:underline font-semibold flex items-center justify-center gap-1 text-sm">
                                          <i class="fas fa-external-link-alt text-[10px] mr-1"></i>{{ dec.MaKB }}
                                        </a>
                                      </td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;">
                                        <div v-if="dec.HinhAnh" class="declaration-image-preview">
                                          <img :src="dec.HinhAnh" alt="Declaration preview" />
                                        </div>
                                        <span v-else class="text-slate-400 text-sm font-medium">Chưa có</span>
                                      </td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 6px;" class="text-slate-700 leading-relaxed text-sm">{{ dec.MoTa }}</td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;" class="text-slate-500 font-mono text-sm">{{ dec.DonViTinh }}</td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: right;" class="font-medium text-slate-800 text-sm">{{ dec.GiaKhaiHQToiThieu | currency }} <sup>₫</sup></td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;" class="font-semibold text-slate-800 text-sm">{{ dec.SoLuong | currency }}</td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;" class="text-slate-500 text-sm">{{ dec.ThueNK | currency }}%</td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;" class="text-slate-500 font-semibold text-sm">{{ dec.ThueVAT | currency }}%</td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;">
                                        <div class="hs-cell-wrapper">
                                          <div class="text-slate-700 font-mono text-sm font-semibold">{{ dec.MaHS || "--" }}</div>
                                          <select
                                            v-model="dec.Consignee"
                                            class="importer-select"
                                            title="Nhà nhập khẩu"
                                            @change="updateDeclarationField(dec, 'Consignee', dec.Consignee)"
                                          >
                                            <option value="">-- Nhà NK --</option>
                                            <option v-for="imp in getImporterOptions(dec.Consignee)" :key="imp" :value="imp">
                                              {{ imp }}
                                            </option>
                                          </select>
                                        </div>
                                      </td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;">
                                        <span class="declaration-status-chip text-sm font-semibold" :style="{ color: get_status_color(dec.Status, declaration_status_list) }">
                                          {{ dec.Status | display_value(declaration_status_list) }}
                                        </span>
                                      </td>
                                      <td class="w-note cell-note" style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px;">
                                        <div class="oi-note-wrapper">
                                          <textarea 
                                            placeholder="Ghi chú …" 
                                            rows="3" 
                                            class="oi-textarea" 
                                            v-model="dec.ChinhSachNhapKhau" 
                                            @blur="updateDeclarationField(dec, 'ChinhSachNhapKhau', dec.ChinhSachNhapKhau)"
                                            @keyup.enter="updateDeclarationField(dec, 'ChinhSachNhapKhau', dec.ChinhSachNhapKhau)"
                                          ></textarea>
                                          <span class="oi-note-label"></span>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-if="!item.hasDeclarations" class="bg-white sub-table-row">
                                      <td colspan="11" style="border: 1px solid rgba(0,0,0,0.1); padding: 16px; text-align: center;" class="text-slate-400 text-base font-medium">
                                        Chưa có khai báo hải quan cho đơn hàng này
                                      </td>
                                    </tr>
                                    <!-- Total Row -->
                                    <tr v-if="item.hasDeclarations" class="bg-slate-100 font-bold">
                                      <td colspan="4" class="text-slate-700 uppercase tracking-wider text-sm text-right pr-3" style="border: 1px solid rgba(0,0,0,0.1); padding: 8px;">
                                        Tổng cộng
                                      </td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: right;" class="text-blue-700 text-sm font-extrabold" title="Tổng thành tiền trước VAT">
                                        <div class="text-[11px] text-slate-500 font-medium">Tiền trước VAT</div>
                                        <div>{{ calculateTotalBeforeVAT(item.declarations) | currency }}<sup>₫</sup></div>
                                      </td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: center;" class="text-blue-700 text-sm font-bold" title="Tổng số lượng">
                                        <div class="text-[11px] text-slate-500 font-medium">Tổng SL</div>
                                        <div>{{ calculateTotalQuantity(item.declarations) | currency }}</div>
                                      </td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: right;" class="text-blue-700 text-sm font-bold" title="Tổng tiền thuế XNK">
                                        <div class="text-[11px] text-slate-500 font-medium">Tiền thuế NK</div>
                                        <div>{{ calculateTotalTaxNK(item.declarations) | currency }}<sup>₫</sup></div>
                                      </td>
                                      <td style="border: 1px solid rgba(0,0,0,0.1); padding: 6px 4px; text-align: right;" class="text-blue-700 text-sm font-bold" title="Tổng tiền thuế VAT">
                                        <div class="text-[11px] text-slate-500 font-medium">Tiền thuế VAT</div>
                                        <div>{{ calculateTotalTaxVAT(item.declarations) | currency }}<sup>₫</sup></div>
                                      </td>
                                      <td colspan="3" style="border: 1px solid rgba(0,0,0,0.1); padding: 8px;"></td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div v-if="isStoreTqQuickFilter" class="mt-3">
                                  <div class="text-sm font-bold text-slate-600 uppercase tracking-wider mb-2">Danh sách mã vận đơn</div>
                                  <table class="sub-package-table shadow-sm rounded overflow-hidden" style="border-collapse: collapse; width: 100%;">
                                    <tbody>
                                      <tr class="sub-table-header text-white font-medium text-sm">
                                        <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: left; width: 125px;">Mã vận đơn</th>
                                        <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: right; width: 55px;">Số kiện</th>
                                        <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: left; width: 110px;">Ghi chú</th>
                                        <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: center; width: 95px;">Trạng thái</th>
                                        <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: left; width: 75px;">Mã xe</th>
                                        <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: right; width: 60px;">Cân (kg)</th>
                                        <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: right; width: 65px;">CBM</th>
                                        <th style="border: 1px solid rgba(255,255,255,0.3); padding: 8px 4px; text-align: center; width: 110px;">Ảnh mã vận đơn</th>
                                      </tr>
                                      <tr v-if="!item.orderPackages || item.orderPackages.length === 0" class="bg-white">
                                        <td colspan="8" style="border: 1px solid rgba(0,0,0,0.1); padding: 12px; text-align: center;" class="text-slate-400 text-sm font-medium">
                                          Chưa có mã vận đơn
                                        </td>
                                      </tr>
                                      <tr v-for="(pkg, pIdx) in item.orderPackages" :key="pkg.ID || `${item.OrderID}_${pIdx}`" :class="pIdx % 2 === 0 ? 'bg-white' : 'bg-slate-50-50'">
                                        <td style="border: 1px solid rgba(0,0,0,0.1); padding: 8px;" class="text-slate-700 font-semibold text-sm">{{ pkg.TransactionCode || '--' }}</td>
                                        <td style="border: 1px solid rgba(0,0,0,0.1); padding: 8px; text-align: right;" class="text-slate-700 text-sm">{{ pkg.NumberOfPack || 1 }}</td>
                                        <td style="border: 1px solid rgba(0,0,0,0.1); padding: 8px;" class="text-slate-700 text-sm">{{ pkg.OrderNote || '--' }}</td>
                                        <td style="border: 1px solid rgba(0,0,0,0.1); padding: 8px; text-align: center;">
                                          <span class="declaration-status-chip text-sm font-semibold" :style="{ color: get_status_color(pkg.Status, package_status_list) }">
                                            {{ pkg.Status | display_value(package_status_list) }}
                                          </span>
                                        </td>
                                        <td style="border: 1px solid rgba(0,0,0,0.1); padding: 8px;" class="text-slate-700 text-sm">{{ pkg.VehicleCode || '--' }}</td>
                                        <td style="border: 1px solid rgba(0,0,0,0.1); padding: 8px; text-align: right;" class="text-slate-700 text-sm">{{ pkg.Weight | currency('', 2) }}</td>
                                        <td style="border: 1px solid rgba(0,0,0,0.1); padding: 8px; text-align: right;" class="text-slate-700 text-sm">
                                          <v-tooltip top max-width="250" color="grey darken-3">
                                            <template v-slot:activator="{ on }">
                                              <span v-on="on" style="cursor: help; border-bottom: 1px dashed #777;">
                                                {{ pkg.Volume | currency('', 4) }}
                                              </span>
                                            </template>
                                            <span>Dài x Rộng x Cao: {{ pkg.Length | currency('', 1) }} x {{ pkg.Width | currency('', 1) }} x {{ pkg.Height | currency('', 1) }}</span>
                                          </v-tooltip>
                                        </td>
                                        <td style="border: 1px solid rgba(0,0,0,0.1); padding: 8px; text-align: center;">
                                          <div v-if="getImageList(pkg).length" class="table-image-list justify-center">
                                            <img
                                              v-for="(image, index) in getImageList(pkg)"
                                              :key="`${image}-${index}`"
                                              :src="proxyImage(image)"
                                              class="table-image-thumb"
                                              @click="openImage(image)"
                                              alt="Ảnh vận đơn"
                                            />
                                          </div>
                                          <span v-else class="text-slate-400 text-sm">Không có ảnh</span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </td>
                            
                            <!-- 4. In phiếu -->
                            <td v-if="!isStoreTqQuickFilter" class="py-4 px-2 col-print">
                              <div class="flex flex-col gap-2 w-full print-buttons-container">
                                <button type="button" :disabled="isExporting('hop_dong_nguyen_tac', item.OrderID)" @click="exportDocument('hop_dong_nguyen_tac', item.OrderID)" class="w-full text-left px-2.5 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg text-base font-semibold flex items-center gap-2 border border-slate-200 transition-colors">
                                  <i class="fas fa-file-contract text-blue-500 mr-1 text-base"></i> HĐ Nguyên Tắc
                                </button>
                                <button type="button" :disabled="isExporting('hop_dong_mbhh', item.OrderID)" @click="openContractDialog(item.OrderID, 'hop_dong_mbhh')" class="w-full text-left px-2.5 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg text-base font-semibold flex items-center gap-2 border border-slate-200 transition-colors">
                                  <i class="fas fa-file-signature text-emerald-500 mr-1 text-base"></i> HĐ Mua Bán
                                </button>
                                <button type="button" :disabled="isExporting('don_dat_hang', item.OrderID)" @click="exportDocument('don_dat_hang', item.OrderID)" class="w-full text-left px-2.5 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg text-base font-semibold flex items-center gap-2 border border-slate-200 transition-colors">
                                  <i class="fas fa-check-double text-indigo-500 mr-1 text-base"></i> Đơn ĐH
                                </button>
                                <button type="button" :disabled="isExporting('bien_ban_giao_nhan_hang_hoa', item.OrderID)" @click="exportDocument('bien_ban_giao_nhan_hang_hoa', item.OrderID)" class="w-full text-left px-2.5 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg text-base font-semibold flex items-center gap-2 border border-slate-200 transition-colors">
                                  <i class="fas fa-check-double text-indigo-500 mr-1 text-base"></i> Biên bản NH
                                </button>
                              </div>
                            </td>
                            
                            <!-- 5. Tình trạng hóa đơn -->
                            <td v-if="!isStoreTqQuickFilter" class="py-4 px-4 col-invoice">
                              <div class="flex flex-col gap-2 w-full invoice-status-container">
                                <button type="button" @click="gotoOrderDetail(item.OrderID)" class="w-full text-center px-3 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-base font-bold shadow-sm transition-all flex items-center justify-center gap-1.5 mb-1 btn-detail-order">
                                  <i class="fas fa-info-circle mr-1 text-base"></i> Chi tiết đơn
                                </button>
                                <label
                                  v-for="statusOption in invoiceStatusOptions"
                                  :key="`${item.OrderID}_${statusOption.payloadField}`"
                                  class="invoice-check-item"
                                  :class="{
                                    'is-checked': !!item[statusOption.field],
                                    'is-disabled': isInvoiceStatusUpdating(item.OrderID, statusOption.payloadField)
                                  }"
                                >
                                  <input
                                    type="checkbox"
                                    class="invoice-check-input"
                                    :checked="!!item[statusOption.field]"
                                    :disabled="isInvoiceStatusUpdating(item.OrderID, statusOption.payloadField)"
                                    @change="toggleInvoiceStatus(item, statusOption, $event.target.checked)"
                                  />
                                  <span class="invoice-check-box">
                                    <i class="fas fa-check"></i>
                                  </span>
                                  <span class="invoice-check-label">{{ statusOption.label }}</span>
                                </label>
                              </div>
                            </td>
                            
                            <!-- 6. Tình trạng khai báo -->
                            <td v-if="isStoreTqQuickFilter" class="py-4 px-4 col-declaration-status">
                              <div class="flex flex-col gap-2 w-full declaration-status-container">
                                <label
                                  class="invoice-check-item"
                                  :class="{
                                    'is-checked': getDeclarationSent(item),
                                    'is-disabled': isDeclarationStatusUpdating(item.OrderID)
                                  }"
                                >
                                  <input
                                    type="checkbox"
                                    class="invoice-check-input"
                                    :checked="getDeclarationSent(item)"
                                    :disabled="isDeclarationStatusUpdating(item.OrderID)"
                                    @change="toggleDeclarationSent(item, $event)"
                                  />
                                  <span class="invoice-check-box">
                                    <i class="fas fa-check"></i>
                                  </span>
                                  <span class="invoice-check-label">Đã gửi khai báo</span>
                                </label>
                              </div>
                            </td>

                            <!-- 6. Lịch sử -->
                            <td v-if="!isStoreTqQuickFilter" class="py-4 px-4 col-history">
                              <div class="space-y-2 text-sm font-medium text-slate-600 history-logs-container">
                                <div
                                  v-for="statusOption in invoiceStatusOptions"
                                  :key="`${item.OrderID}_${statusOption.field}_history`"
                                  class="bg-slate-50 p-2 rounded border border-slate-100 flex flex-col gap-0.5 history-log-item"
                                >
                                  <span class="text-slate-400 font-semibold text-xs uppercase">{{ statusOption.historyLabel }}</span>
                                  <span class="text-slate-700 font-mono font-bold text-sm">{{ formatInvoiceHistory(item[statusOption.field]) }}</span>
                                </div>
                              </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    
    <!-- Print Preview Dialog -->
    <v-dialog v-model="printModalVisible" max-width="400px" content-class="print-modal-dialog">
      <div class="bg-white rounded-2xl p-6 border border-slate-100 print-modal-inner">
        <!-- Header -->
        <div class="flex justify-between items-start pb-2 border-b border-slate-100 header-row">
          <div class="flex items-center gap-2">
            <div class="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center mr-2">
              <i class="fas fa-file-invoice text-blue-500"></i>
            </div>
            <span class="text-xs font-bold text-slate-400 uppercase tracking-wider">In tài liệu: MD{{ printOrderCode }}</span>
          </div>
          <button type="button" @click="printModalVisible = false" class="text-slate-400 hover:text-slate-600 transition-colors">
            <i class="fas fa-times"></i>
          </button>
        </div>
        
        <!-- Body Content -->
        <div class="flex items-start gap-3 pt-4 body-row">
          <div class="text-blue-500 mt-0.5 mr-2">
            <i class="fas fa-print fa-2x text-blue-500"></i>
          </div>
          <div>
            <h4 class="font-bold text-slate-800 text-sm">{{ printDocName }}</h4>
            <p class="text-xs text-slate-500">Mã đơn: <span class="font-bold text-red-600">MD{{ printOrderCode }}</span></p>
          </div>
        </div>
        <p class="text-xs text-slate-600 leading-relaxed mt-2 desc-para">
          Hệ thống đang khởi tạo mẫu tài liệu in ấn và chuẩn bị tải xuống. Vui lòng xác nhận để in trực tiếp hoặc xuất tệp PDF.
        </p>
        
        <!-- Actions -->
        <div class="space-y-2 mt-4 footer-actions">
          <label class="text-[11px] font-bold text-slate-400 uppercase block mb-1">Tùy chọn xuất bản</label>
          <div class="grid grid-cols-2 gap-2 mt-1 buttons-grid">
            <button type="button" @click="triggerPrint('print')" class="py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold rounded-lg transition-colors flex items-center justify-center gap-1.5 shadow-sm btn-print">
              <i class="fas fa-print mr-1"></i> In ngay
            </button>
            <button type="button" @click="triggerPrint('pdf')" class="py-2.5 bg-slate-800 hover:bg-slate-700 text-white text-xs font-bold rounded-lg transition-colors flex items-center justify-center gap-1.5 btn-pdf">
              <i class="fas fa-download mr-1"></i> Tải PDF
            </button>
          </div>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="createVehicleDialog" max-width="460px">
      <v-card>
        <v-card-title class="headline">Tạo xe hàng</v-card-title>
        <v-card-text>
          <div class="text-sm text-slate-600 mb-4">
            Tạo xe từ <strong>{{ selectedOrderIds.length }}</strong> đơn hàng đã chọn, trạng thái mặc định <strong>Đang xếp</strong>.
          </div>
          <v-text-field
            v-model="createVehicleForm.LicensePlate"
            label="Biển số xe"
            autofocus
            :disabled="createVehicleLoading"
            @keyup.enter="submitCreateVehicle"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeCreateVehicleDialog" :disabled="createVehicleLoading">Hủy</v-btn>
          <v-btn color="primary" @click="submitCreateVehicle" :loading="createVehicleLoading" :disabled="createVehicleLoading">
            Tạo xe hàng
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateVehicleDialog" max-width="520px">
      <v-card>
        <v-card-title class="headline">Cập nhật xe hàng</v-card-title>
        <v-card-text>
          <div class="text-sm text-slate-600 mb-4">
            Chọn xe để đưa <strong>{{ selectedOrderIds.length }}</strong> đơn hàng đã chọn vào xe tương ứng.
          </div>
          <v-select
            v-model="updateVehicleForm.VehicleID"
            :items="vehicleOptions"
            item-text="label"
            item-value="ID"
            label="Chọn xe hàng"
            :loading="vehicleOptionsLoading"
            :disabled="updateVehicleLoading"
            no-data-text="Không có xe hàng"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeUpdateVehicleDialog" :disabled="updateVehicleLoading">Hủy</v-btn>
          <v-btn color="primary" @click="submitUpdateVehicle" :loading="updateVehicleLoading" :disabled="updateVehicleLoading || !updateVehicleForm.VehicleID">
            Cập nhật xe
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="contractDialog.show" max-width="500px">
      <v-card>
        <v-card-title class="headline">Mã hợp đồng mua bán</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="contractDialog.code"
            label="Nhập mã hợp đồng mua bán"
            autofocus
            @keyup.enter="submitContractCode"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="contractDialog.show = false">Hủy</v-btn>
          <v-btn color="primary" @click="submitContractCode">
            Xác nhận
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice, parseImageList, proxyImage } from '@/commons/utils';

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            configs,
            search: "",
            headers: [{
                    text: "ID",
                    value: "ID",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Mã ĐH",
                    value: "OrderID",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Mã KB",
                    value: "MaKB",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Mã HS",
                    value: "MaHS",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Hình ảnh",
                    value: "HinhAnh",
                    filterable: false,
                    quickSearch: false,
                    dataType: dataType["String"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: dataType["Enum"],
                    values: configs.DECLARE_STATUS_LIST
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: dataType["Date"]
                },
                {
                    text: "Người tạo",
                    value: "CreatedBy",
                    filterable: true,
                    dataType: dataType["String"]
                }
            ],
            baseTableHeaders: [
                { text: "", value: "select", align: "center", sortable: false, width: "36px", class: "col-select" },
                { text: "#", value: "index", align: "center", sortable: false, width: "35px", class: "col-seq" },
                { text: "Đơn hàng", value: "OrderID", sortable: false, width: "135px", class: "col-order" },
                { text: "Chi tiết hàng hóa viết hóa đơn", value: "declarations", sortable: false, class: "col-details", width: '1185px' },
                { text: "In phiếu", value: "print", sortable: false, width: "135px", class: "col-print" },
                { text: "Tình trạng hóa đơn", value: "invoice_status", sortable: false, width: "180px", class: "col-invoice" },
                { text: "Lịch sử", value: "history", sortable: false, width: "140px", class: "col-history" }
            ],
            invoiceStatusOptions: [
                { label: "Đã trả hoá đơn nháp", field: "OrderInvoiceDraftDate", payloadField: "InvoiceDraftDate", historyLabel: "HĐ nháp" },
                { label: "Đã trả hoá đơn VAT", field: "OrderInvoiceVATDate", payloadField: "InvoiceVATDate", historyLabel: "HĐ VAT" },
                { label: "Đã gửi HĐ", field: "OrderInvoiceSentDate", payloadField: "InvoiceSentDate", historyLabel: "Gửi HĐ" },
                { label: "Đã lưu trữ HĐ", field: "OrderInvoiceArchivedDate", payloadField: "InvoiceArchivedDate", historyLabel: "Lưu trữ" }
            ],
            declaration_status_list: configs.DECLARE_STATUS_LIST,
            package_status_list: configs.PACKAGE_STATUS,
            declaration_status: configs.DECLARATION_STATUS,
            pagination: { ...configs.PAGINATION, sortBy: ["OrderID"], sortDesc: ['true']},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "declaration_list",
            filterConditions: [],
            quickFilterConditions: [],
            
            selectedStatusFilter: 'all',
            selectedDecStatuses: [],
            selectedInvoiceStatuses: [],
            subInvoiceStatusOptions: [
                { key: "draft", label: "Đã trả hóa đơn nháp" },
                { key: "vat", label: "Đã trả hóa đơn VAT" },
                { key: "sent", label: "Đã gửi HĐ" },
                { key: "archived", label: "Đã lưu trữ HĐ" }
            ],
            selectedDeclarationSendFilter: 'all',
            selectedOrderIds: [],
            exportLoadingKey: '',
            declarationExcelLoading: false,
            invoiceStatusLoadingKey: '',
            declarationStatusLoadingOrderId: null,
            createVehicleDialog: false,
            createVehicleLoading: false,
            createVehicleForm: {
                LicensePlate: ''
            },
            updateVehicleDialog: false,
            updateVehicleLoading: false,
            vehicleOptionsLoading: false,
            updateVehicleForm: {
                VehicleID: null
            },
            printModalVisible: false,
            printDocName: '',
            printOrderCode: '',
            contractDialog: {
                show: false,
                code: '',
                date: '',
                orderId: null,
                docType: ''
            }
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            orders: state => state.declaration.all.data,
            total_rows: state => state.declaration.all.total,
            loading: state => state.declaration.loading,
            all_users: state => state.commons.all_users,
            vehicles: state => state.vehicle.all.data,
            summary: state => state.declaration.summary,
        }),
        configuration() {
            return (this.$store.state.configuration && this.$store.state.configuration.selected)
                ? this.$store.state.configuration.selected
                : {};
        },
        importerOptions() {
            const configImporters = this.configuration && this.configuration.Importers ? this.configuration.Importers : "";
            if (!configImporters) return [];
            return configImporters
                .split(",")
                .map(s => s.trim())
                .filter(s => s.length > 0);
        },
        isStoreTqQuickFilter() {
            return this.selectedStatusFilter === 'da_nhap_kho_tq';
        },
        canCreateVehicle() {
            return this.isStoreTqQuickFilter && this.selectedOrderIds.length > 0 && !this.createVehicleLoading;
        },
        canUpdateVehicle() {
            return this.isStoreTqQuickFilter && this.selectedOrderIds.length > 0 && !this.updateVehicleLoading;
        },
        vehicleOptions() {
            return (this.vehicles || []).map(vehicle => ({
                ...vehicle,
                label: `${vehicle.VehicleCode || '---'} - ${vehicle.LicensePlate || 'Chưa có biển số'}`
            }));
        },
        displayTableHeaders() {
            if (this.isStoreTqQuickFilter) {
                return [
                    this.baseTableHeaders[0],
                    this.baseTableHeaders[1],
                    this.baseTableHeaders[2],
                    this.baseTableHeaders[3],
                    { text: "Tình trạng khai báo", value: "declaration_status", sortable: false, width: "190px", class: "col-declaration-status" }
                ];
            }
            return this.baseTableHeaders;
        },
        isAllCurrentPageSelected() {
            return this.filteredGroupedOrders.length > 0 && this.filteredGroupedOrders.every(item => this.isOrderSelected(item.OrderID));
        },
        groupedOrders() {
            if (!this.orders || this.orders.length === 0) return [];
            const groups = _.groupBy(this.orders, 'OrderID');
            const result = [];
            const visited = new Set();
            this.orders.forEach(item => {
                if (!visited.has(item.OrderID)) {
                    visited.add(item.OrderID);
                    const decs = groups[item.OrderID] || [];
                    const declarations = decs.filter(dec => dec && dec.ID !== null && dec.ID !== undefined);
                    result.push({
                        OrderID: item.OrderID,
                        Username: item.Username,
                        OrderStatus: item.OrderStatus,
                        OrderBuyerID: item.OrderBuyerID,
                        OrderCustomerServiceID: item.OrderCustomerServiceID,
                        OrderSalerID: item.OrderSalerID,
                        OrderXNKID: item.OrderXNKID,
                        OrderBoughtDate: item.OrderBoughtDate,
                        OrderStoreVNImDate: item.OrderStoreVNImDate,
                        OrderStoreVNExDate: item.OrderStoreVNExDate,
                        OrderCompletedDate: item.OrderCompletedDate,
                        OrderInvoiceDraftDate: item.OrderInvoiceDraftDate,
                        OrderInvoiceVATDate: item.OrderInvoiceVATDate,
                        OrderInvoiceSentDate: item.OrderInvoiceSentDate,
                        OrderInvoiceArchivedDate: item.OrderInvoiceArchivedDate,
                        OrderIsDeclarationSent: item.OrderIsDeclarationSent,
                        OrderDeclarationSentDate: item.OrderDeclarationSentDate,
                        OrderTotalAmountVND: item.OrderTotalAmountVND || 0,
                        OrderDeposit: item.OrderDeposit || 0,
                        OrderRemainAmount: item.OrderRemainAmount || 0,
                        OrderTotalInvoicePrice: item.OrderTotalInvoicePrice || 0,
                        OrderTaxNKRate: item.OrderTaxNKRate || 0,
                        OrderTaxNKAmount: item.OrderTaxNKAmount || 0,
                        OrderTaxVATRate: item.OrderTaxVATRate || 0,
                        OrderTaxVATAmount: item.OrderTaxVATAmount || 0,
                        OrderTaxOtherRate: item.OrderTaxOtherRate || 0,
                        OrderTaxOtherAmount: item.OrderTaxOtherAmount || 0,
                        OrderSurcharge1Rate: item.OrderSurcharge1Rate || 0,
                        OrderSurcharge1Amount: item.OrderSurcharge1Amount || 0,
                        OrderSurcharge2Rate: item.OrderSurcharge2Rate || 0,
                        OrderSurcharge2Amount: item.OrderSurcharge2Amount || 0,
                        orderPackages: item.OrderPackages || [],
                        declarations,
                        hasDeclarations: declarations.length > 0
                    });
                }
            });
            return result;
        },
        filteredGroupedOrders() {
            return this.groupedOrders;
        },
        totalOrdersCount() {
            return (this.summary && this.summary.status_counts && this.summary.status_counts.all) || 0;
        },
        storeTqOrdersCount() {
            return (this.summary && this.summary.status_counts && this.summary.status_counts.da_nhap_kho_tq) || 0;
        },
        storeVnOrdersCount() {
            return (this.summary && this.summary.status_counts && this.summary.status_counts.da_nhap_kho_vn) || 0;
        },
        otherOrdersCount() {
            return (this.summary && this.summary.status_counts && this.summary.status_counts.other) || 0;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions,
                quickStatus: this.selectedStatusFilter,
                declarationSendFilter: this.selectedDeclarationSendFilter,
                decStatusFilter: (this.selectedDecStatuses || []).join(','),
                invoiceStatusFilter: (this.selectedInvoiceStatuses || []).join(',')
            };
            this.$store.dispatch("declaration/getList", param);
        },
        getStaffNameById(staffId) {
            if (!staffId) {
                return 'Chưa phân công';
            }
            const matched = (this.all_users || []).find(user => Number(user.ID) === Number(staffId));
            return matched ? matched.FullName : 'Chưa phân công';
        },
        formatRateAmount(rate, amount) {
            const safeRate = Number(rate) || 0;
            const safeAmount = Number(amount) || 0;
            if (safeRate > 0 && safeAmount > 0) {
                return `${this.formatDecimal(safeRate)}% / ${this.$options.filters.currency(safeAmount)}`;
            }
            if (safeRate > 0) {
                return `${this.formatDecimal(safeRate)}%`;
            }
            return this.$options.filters.currency(safeAmount);
        },
        gotoDetail: function (id) {
            let routeData = this.$router.resolve({
                name: "DeclarationDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết khai báo (#${id})`
                },
            });
            window.open(routeData.href, "_blank");
        },
        cancelItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id, `Bạn muốn hủy khai báo #${id} ?`);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getImageList(pkg) {
            return parseImageList(pkg && pkg.StoreCNImages).slice(0, 3);
        },
        proxyImage(url) {
            return proxyImage(url);
        },
        openImage(url) {
            if (!url) {
                return;
            }
            window.open(url, "_blank");
        },
        updateDeclarationField(decItem, field, value) {
            const payload = {
                ...decItem,
                [field]: value
            };
            const allowedFields = ["ID", "UID", "OrderID", "MaKB", "MaHS", "HSCODE", "HSCode", "Nguon", "Consignee", "HinhAnh", "LinkGoogleDrive", "GoogleDriveLink", "GoogleDrive", "ThuongHieu", "TenNhaCungCap", "Brand", "SoKien", "PackageCount", "TenNhaCungCap", "NhaCungCap", "SupplierName", "MoTa", "GiaKhaiHQToiThieu", "DonViTinh", "SoLuong", "ThueNK", "ThueVAT", "ThueTTDB", "ThueTuVe", "ThueMoiTruong", "ChinhSachNhapKhau", "ChiPhiChuyenNganh", "Status"];
            const cleanPayload = {};
            allowedFields.forEach(f => {
                if (payload[f] !== undefined) {
                    cleanPayload[f] = payload[f];
                }
            });
            this.$store.dispatch("declaration/setDetail", { data: cleanPayload, id: cleanPayload.ID });
        },
        exportDeclarationExcel() {
            if (this.declarationExcelLoading) {
                return;
            }
            if (this.selectedOrderIds.length === 0) {
                sendErrorNotice('Vui lòng tích chọn ít nhất 1 đơn hàng để xuất file');
                return;
            }
            const payload = {
                order_ids: this.selectedOrderIds.join(',')
            };

            this.declarationExcelLoading = true;
            this.$store.dispatch("declaration/exportDeclaration", payload)
                .finally(() => {
                    this.declarationExcelLoading = false;
                });
        },
        openCreateVehicleDialog() {
            if (!this.canCreateVehicle) {
                return;
            }
            this.createVehicleForm.LicensePlate = '';
            this.createVehicleDialog = true;
        },
        closeCreateVehicleDialog() {
            if (this.createVehicleLoading) {
                return;
            }
            this.createVehicleDialog = false;
            this.createVehicleForm.LicensePlate = '';
        },
        submitCreateVehicle() {
            if (this.createVehicleLoading) {
                return;
            }

            const licensePlate = (this.createVehicleForm.LicensePlate || '').trim();
            if (licensePlate === '') {
                sendErrorNotice('Vui lòng nhập biển số xe');
                return;
            }
            if (!this.isStoreTqQuickFilter) {
                sendErrorNotice('Chỉ có thể tạo xe hàng ở bộ lọc Đã nhập kho TQ');
                return;
            }
            if (this.selectedOrderIds.length === 0) {
                sendErrorNotice('Vui lòng tích chọn ít nhất 1 đơn hàng');
                return;
            }

            this.createVehicleLoading = true;
            this.$store.dispatch("vehicle/setDetail", {
                data: {
                    LicensePlate: licensePlate,
                    Status: configs.VEHICLE_STATUS_ENUM.DANG_XEP,
                    OrderIDs: this.selectedOrderIds
                },
                id: 0
            }).then(() => {
                this.createVehicleDialog = false;
                this.createVehicleForm.LicensePlate = '';
                this.selectedOrderIds = [];
                this.filter_data();
            }).catch(() => {
            }).finally(() => {
                this.createVehicleLoading = false;
            });
        },
        openUpdateVehicleDialog() {
            if (!this.canUpdateVehicle) {
                return;
            }
            this.updateVehicleForm.VehicleID = null;
            this.updateVehicleDialog = true;
            this.loadVehicleOptions();
        },
        closeUpdateVehicleDialog() {
            if (this.updateVehicleLoading) {
                return;
            }
            this.updateVehicleDialog = false;
            this.updateVehicleForm.VehicleID = null;
        },
        loadVehicleOptions() {
            this.vehicleOptionsLoading = true;
            this.$store.dispatch("vehicle/getList", {
                filter: [
                    {
                        column: 'status',
                        value: configs.VEHICLE_STATUS_ENUM.DANG_XEP,
                        condition: 'equal'
                    }
                ],
                pagination: {
                    ...configs.PAGINATION,
                    page: 1,
                    itemsPerPage: 1000,
                    sortBy: ['ID'],
                    sortDesc: [true]
                }
            }).finally(() => {
                this.vehicleOptionsLoading = false;
            });
        },
        submitUpdateVehicle() {
            if (this.updateVehicleLoading) {
                return;
            }
            if (!this.isStoreTqQuickFilter) {
                sendErrorNotice('Chỉ có thể cập nhật xe ở bộ lọc Đã nhập kho TQ');
                return;
            }
            if (this.selectedOrderIds.length === 0) {
                sendErrorNotice('Vui lòng tích chọn ít nhất 1 đơn hàng');
                return;
            }
            if (!this.updateVehicleForm.VehicleID) {
                sendErrorNotice('Vui lòng chọn xe hàng');
                return;
            }

            this.updateVehicleLoading = true;
            this.$store.dispatch("vehicle/setDetail", {
                data: {
                    OrderIDs: this.selectedOrderIds
                },
                id: this.updateVehicleForm.VehicleID
            }).then(() => {
                this.updateVehicleDialog = false;
                this.updateVehicleForm.VehicleID = null;
                this.selectedOrderIds = [];
                this.filter_data();
            }).catch(() => {
            }).finally(() => {
                this.updateVehicleLoading = false;
            });
        },
        calculateTotalBeforeVAT(declarations) {
            if (!declarations) return 0;
            return declarations.reduce((sum, item) => {
                const qty = parseFloat(item.SoLuong) || 0;
                const price = parseFloat(item.GiaKhaiHQToiThieu) || 0;
                return sum + (price * qty);
            }, 0);
        },
        calculateTotalQuantity(declarations) {
            if (!declarations) return 0;
            return declarations.reduce((sum, item) => {
                const qty = parseFloat(item.SoLuong) || 0;
                return sum + qty;
            }, 0);
        },
        calculateTotalTaxNK(declarations) {
            if (!declarations) return 0;
            return declarations.reduce((sum, item) => {
                const qty = parseFloat(item.SoLuong) || 0;
                const price = parseFloat(item.GiaKhaiHQToiThieu) || 0;
                const taxNK = parseFloat(item.ThueNK) || 0;
                return sum + (price * qty * taxNK / 100);
            }, 0);
        },
        calculateTotalTaxVAT(declarations) {
            if (!declarations) return 0;
            return declarations.reduce((sum, item) => {
                const qty = parseFloat(item.SoLuong) || 0;
                const price = parseFloat(item.GiaKhaiHQToiThieu) || 0;
                const taxVAT = parseFloat(item.ThueVAT) || 0;
                const lineAmount = price * qty;
                const lineTaxVAT = (lineAmount) * (taxVAT / 100);
                return sum + lineTaxVAT;
            }, 0);
        },
        getImporterOptions(currentVal) {
            const list = [...this.importerOptions];
            if (currentVal && !list.includes(currentVal)) {
                list.unshift(currentVal);
            }
            return list;
        },
        isOrderSelected(orderId) {
            return this.selectedOrderIds.includes(Number(orderId));
        },
        toggleOrderSelection(orderId, checked) {
            const normalizedOrderId = Number(orderId);
            if (checked) {
                if (!this.selectedOrderIds.includes(normalizedOrderId)) {
                    this.selectedOrderIds.push(normalizedOrderId);
                }
                return;
            }
            this.selectedOrderIds = this.selectedOrderIds.filter(id => Number(id) !== normalizedOrderId);
        },
        toggleCurrentPageSelection() {
            if (this.isAllCurrentPageSelected) {
                const currentPageIds = this.filteredGroupedOrders.map(item => Number(item.OrderID));
                this.selectedOrderIds = this.selectedOrderIds.filter(id => !currentPageIds.includes(Number(id)));
                return;
            }
            const merged = new Set(this.selectedOrderIds.map(id => Number(id)));
            this.filteredGroupedOrders.forEach(item => {
                merged.add(Number(item.OrderID));
            });
            this.selectedOrderIds = Array.from(merged);
        },
        setQuickStatusFilter(status) {
            this.selectedStatusFilter = status;
            this.selectedDecStatuses = [];
            this.selectedInvoiceStatuses = [];
            const statusLabels = {
                all: 'Tất cả',
                da_nhap_kho_tq: 'Đã nhập kho TQ',
                da_nhap_kho_vn: 'Đã nhập kho VN',
                other: 'Đơn khác'
            };
            const label = statusLabels[status] || 'Tất cả';
            sendSuccessNotice(`Đã lọc trạng thái: ${label}`);
            this.pagination.page = 1;
            this.filter_data();
        },
        onSubFilterChange() {
            this.pagination.page = 1;
            this.filter_data();
        },
        onDeclarationSendFilterChange() {
            this.pagination.page = 1;
            this.filter_data();
        },
        showPrintModal(docName, orderId) {
            this.printDocName = docName;
            this.printOrderCode = orderId;
            this.printModalVisible = true;
        },
        getExportKey(docType, orderId) {
            return `${docType}_${orderId}`;
        },
        isExporting(docType, orderId) {
            return this.exportLoadingKey === this.getExportKey(docType, orderId);
        },
        getInvoiceStatusLoadingKey(orderId, payloadField) {
            return `${orderId}_${payloadField}`;
        },
        isInvoiceStatusUpdating(orderId, payloadField) {
            return this.invoiceStatusLoadingKey === this.getInvoiceStatusLoadingKey(orderId, payloadField);
        },
        isDeclarationStatusUpdating(orderId) {
            return Number(this.declarationStatusLoadingOrderId) === Number(orderId);
        },
        getDeclarationSent(item) {
            return item.OrderIsDeclarationSent === true || Number(item.OrderIsDeclarationSent) === 1;
        },
        formatDateTimeForApi(date = new Date()) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        formatInvoiceHistory(value) {
            return value ? this.$options.filters.display_date(value, 'DD/MM/YYYY HH:mm') : '-- : --';
        },
        toggleInvoiceStatus(item, statusOption, checked) {
            const loadingKey = this.getInvoiceStatusLoadingKey(item.OrderID, statusOption.payloadField);
            if (this.invoiceStatusLoadingKey === loadingKey) {
                return;
            }

            const previousValue = item[statusOption.field];
            const nextValue = checked ? this.formatDateTimeForApi() : null;

            this.invoiceStatusLoadingKey = loadingKey;
            this.$set(item, statusOption.field, nextValue);

            this.$store.dispatch("main_order/patchOrderFields", {
                orderId: item.OrderID,
                fields: {
                    [statusOption.payloadField]: nextValue
                }
            }).then((res) => {
                if (!res || res.status !== 200) {
                    throw new Error('patch_failed');
                }
                this.filter_data();
            }).catch(() => {
                this.$set(item, statusOption.field, previousValue);
                sendErrorNotice('Không thể cập nhật tình trạng hóa đơn');
            }).finally(() => {
                this.invoiceStatusLoadingKey = '';
            });
        },
        toggleDeclarationSent(item, event) {
            const checked = event.target.checked;
            if (this.isDeclarationStatusUpdating(item.OrderID)) {
                event.target.checked = !checked;
                return;
            }

            const confirmMsg = checked 
                ? "Bạn có chắc chắn muốn xác nhận đã gửi khai báo cho đơn hàng này?" 
                : "Bạn có chắc chắn muốn hủy xác nhận đã gửi khai báo cho đơn hàng này?";

            if (!confirm(confirmMsg)) {
                event.target.checked = !checked;
                return;
            }

            const previousValue = item.OrderIsDeclarationSent;
            const nextValue = checked ? 1 : 0;

            this.declarationStatusLoadingOrderId = item.OrderID;
            this.$set(item, 'OrderIsDeclarationSent', nextValue);

            this.$store.dispatch("main_order/patchOrderFields", {
                orderId: item.OrderID,
                fields: {
                    IsDeclarationSent: nextValue
                }
            }).then((res) => {
                if (!res || res.status !== 200) {
                    throw new Error('patch_failed');
                }
                sendSuccessNotice("Cập nhật tình trạng khai báo thành công");
            }).catch(() => {
                this.$set(item, 'OrderIsDeclarationSent', previousValue);
                sendErrorNotice('Không thể cập nhật tình trạng khai báo');
            }).finally(() => {
                this.declarationStatusLoadingOrderId = null;
            });
        },
        getFileNameFromDisposition(disposition, fallbackName) {
            if (!disposition) return fallbackName;
            const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
            if (utfMatch && utfMatch[1]) {
                return decodeURIComponent(utfMatch[1]);
            }
            const asciiMatch = disposition.match(/filename="?([^"]+)"?/i);
            return asciiMatch && asciiMatch[1] ? asciiMatch[1] : fallbackName;
        },
        async parseBlobError(blob) {
            if (!blob || typeof blob.text !== 'function') return 'Không thể xuất tài liệu';
            try {
                const text = await blob.text();
                const parsed = JSON.parse(text);
                return parsed.reason || parsed.message || 'Không thể xuất tài liệu';
            } catch (e) {
                return 'Không thể xuất tài liệu';
            }
        },
        openContractDialog(orderId, docType) {
            this.contractDialog.orderId = orderId;
            this.contractDialog.docType = docType;
            const order = this.orders.find(o => o.OrderID === orderId);
            if (docType === 'hop_dong_mbhh') {
                this.contractDialog.code = order ? (order.ContractCodeHDMB || '') : '';
            }
            this.contractDialog.show = true;
        },
        submitContractCode() {
            const code = this.contractDialog.code.trim();
            if (!code) {
                sendErrorNotice("Vui lòng nhập mã hợp đồng");
                return;
            }
            
            const order = this.orders.find(o => o.OrderID === this.contractDialog.orderId);
            if (order) {
                if (this.contractDialog.docType === 'hop_dong_mbhh') {
                    this.$set(order, 'ContractCodeHDMB', code);
                }
            }

            this.contractDialog.show = false;
            this.exportDocument(this.contractDialog.docType, this.contractDialog.orderId, code, this.contractDialog.date);
        },
        exportDocument(docType, orderId, contractCode = '', contractDate = ''){
          const exportKey = this.getExportKey(docType, orderId);
          if (this.exportLoadingKey === exportKey) {
            return;
          }

          this.exportLoadingKey = exportKey;
          const fallbackName = `${docType}_${orderId}.docx`;
          const req = {
            headers: {
              Authorization: `Bearer ${this.$store.state.authentication.token}`
            },
            responseType: 'blob'
          };

          let url = `${configs.API}/admin/api/declaration/export_document/?order_id=${orderId}&doc_type=${docType}`;
          if (contractCode) {
              url += `&contract_code=${encodeURIComponent(contractCode)}`;
          }
          if (contractDate) {
              url += `&contract_date=${encodeURIComponent(contractDate)}`;
          }

          this.$http.get(url, req)
            .then((res) => {
              const disposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
              const fileName = this.getFileNameFromDisposition(disposition, fallbackName);
              const blob = new Blob([
                res.data
              ], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
              sendSuccessNotice('Xuất tài liệu thành công');
            })
            .catch(async (err) => {
              const message = await this.parseBlobError(err && err.response ? err.response.data : null);
              sendErrorNotice(message);
            })
            .finally(() => {
              this.exportLoadingKey = '';
            });
        },
        triggerPrint(format) {
            this.printModalVisible = false;
            const msg = format === 'print' ? 'Đang gửi lệnh in tới máy in...' : 'Đang xuất tệp PDF...';
            sendSuccessNotice(msg);
        },
        gotoOrderDetail(orderId) {
            let routeData = this.$router.resolve({
                name: "OrderDetail",
                params: {
                    Pid: orderId,
                    title: `Chi tiết đơn hàng (#${orderId})`
                },
            });
            window.open(routeData.href, "_blank");
        },
        getOrderStatusName(status) {
            const matched = configs.ORDER_STATUS.find(o => o.value === status);
            return matched ? matched.name : 'Chưa rõ';
        },
        getOrderStatusColor(status) {
            const matched = configs.ORDER_STATUS.find(o => o.value === status);
            return matched ? matched.color : '#000000';
        },
        getOrderStatusStyle(status) {
            const matched = configs.ORDER_STATUS.find(o => o.value === status);
            if (matched) {
                if (status === 6) {
                    return { backgroundColor: '#fee2e2', color: '#991b1b', borderColor: '#fca5a5', border: '1px solid' };
                }
                const color = matched.color || '#64748b';
                return {
                    backgroundColor: color + '15',
                    color: color,
                    borderColor: color + '30',
                    border: '1px solid'
                };
            }
            return { backgroundColor: '#f1f5f9', color: '#64748b' };
        },
        formatDecimal(val) {
            if (val === null || val === undefined || val === '') return '0';
            const num = parseFloat(val);
            if (isNaN(num)) return '0';
            return parseFloat(num.toFixed(2)).toString();
        }
    },
    mounted() {
        if (!this.configuration || !this.configuration.ID) {
            this.$store.dispatch("configuration/getDetail", 1);
        }
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
            var updateDeclaration = {
                "ID": id,
                "Status": this.declaration_status.Cancel
            }
            this.$store.dispatch("declaration/setDetail", { data: updateDeclaration, id: updateDeclaration.ID });
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>

<style scoped>
/* Base container background styling matching mockup */
.declaration-list-container {
  background-color: #ffffff !important;
  min-height: 100vh;
}

/* Padding and Margins */
.p-2 { padding: 8px !important; }
.p-4 { padding: 16px !important; }
.p-6 { padding: 24px !important; }
.pa-0 { padding: 0 !important; }
.ma-0 { margin: 0 !important; }
.py-1 { padding-top: 4px !important; padding-bottom: 4px !important; }
.py-2 { padding-top: 8px !important; padding-bottom: 8px !important; }
.py-2\.5 { padding-top: 10px !important; padding-bottom: 10px !important; }
.py-4 { padding-top: 16px !important; padding-bottom: 16px !important; }
.px-2\.5 { padding-left: 10px !important; padding-right: 10px !important; }
.px-3 { padding-left: 12px !important; padding-right: 12px !important; }
.px-4 { padding-left: 16px !important; padding-right: 16px !important; }
.py-1\.5 { padding-top: 6px !important; padding-bottom: 6px !important; }

.mb-1 { margin-bottom: 4px !important; }
.mb-2 { margin-bottom: 8px !important; }
.mr-1 { margin-right: 4px !important; }
.mr-2 { margin-right: 8px !important; }
.mt-2 { margin-top: 8px !important; }
.mt-3 { margin-top: 12px !important; }
.mt-4 { margin-top: 16px !important; }

/* Display & Layout */
.flex {
  display: flex !important;
  flex: initial !important; /* Prevent Vuetify from overriding with flex: 1 1 auto */
}
.flex-col { flex-direction: column !important; }
.flex-wrap { flex-wrap: wrap !important; }
.items-center { align-items: center !important; }
.items-start { align-items: flex-start !important; }
.justify-center { justify-content: center !important; }
.justify-between { justify-content: space-between !important; }
.inline-flex { display: inline-flex !important; }
.block { display: block !important; }

.grid { display: grid !important; }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
.gap-0\.5 { gap: 2px !important; }
.gap-1\.5 { gap: 6px !important; }
.gap-2 { gap: 8px !important; }
.gap-3 { gap: 12px !important; }

/* Width & Height */
.w-full { width: 100% !important; }
.w-8 { width: 32px !important; }
.h-8 { height: 32px !important; }

/* Font Styles */
.font-mono { font-family: monospace !important; }
.font-medium { font-weight: 500 !important; }
.font-semibold { font-weight: 600 !important; }
.font-bold { font-weight: 700 !important; }
.font-extrabold { font-weight: 800 !important; }
.text-xs { font-size: 12px !important; }
.text-sm { font-size: 14px !important; }
.text-\[10px\] { font-size: 10px !important; }
.text-\[11px\] { font-size: 11px !important; }
.text-center { text-align: center !important; }
.text-left { text-align: left !important; }
.text-right { text-align: right !important; }
.uppercase { text-transform: uppercase !important; }
.leading-relaxed { line-height: 1.625 !important; }

/* Colors & Backgrounds */
.bg-slate-50 { background-color: #f8fafc !important; }
.bg-slate-100 { background-color: #f1f5f9 !important; }
.bg-slate-200 { background-color: #e2e8f0 !important; }
.bg-slate-300 { background-color: #cbd5e1 !important; }
.bg-red-50 { background-color: #fef2f2 !important; }
.bg-red-100 { background-color: #fee2e2 !important; }
.bg-red-200 { background-color: #fecaca !important; }
.bg-red-500 { background-color: #ef4444 !important; }
.bg-slate-400 { background-color: #94a3b8 !important; }
.bg-amber-50 { background-color: #fffbeb !important; }
.bg-amber-100 { background-color: #fef3c7 !important; }
.bg-amber-200 { background-color: #fde68a !important; }
.bg-amber-500 { background-color: #f59e0b !important; }
.bg-blue-50 { background-color: #eff6ff !important; }
.bg-blue-100 { background-color: #dbeafe !important; }
.bg-blue-600 { background-color: #2563eb !important; }
.bg-purple-100 { background-color: #f3e8ff !important; }
.bg-emerald-50 { background-color: #ecfdf5 !important; }
.bg-emerald-100 { background-color: #d1fae5 !important; }
.bg-emerald-200 { background-color: #a7f3d0 !important; }
.bg-emerald-500 { background-color: #10b981 !important; }
.bg-emerald-600 { background-color: #059669 !important; }
.bg-emerald-700 { background-color: #047857 !important; }
.bg-slate-800 { background-color: #1e293b !important; }

.bg-slate-50-50 {
  background-color: rgba(248, 250, 252, 0.5) !important;
}

/* Text Colors */
.text-slate-400 { color: #94a3b8 !important; }
.text-slate-500 { color: #64748b !important; }
.text-slate-600 { color: #475569 !important; }
.text-slate-700 { color: #334155 !important; }
.text-slate-800 { color: #1e293b !important; }
.text-red-600 { color: #dc2626 !important; }
.text-red-700 { color: #b91c1c !important; }
.text-red-800 { color: #991b1b !important; }
.text-amber-700 { color: #b45309 !important; }
.text-blue-500 { color: #3b82f6 !important; }
.text-blue-600 { color: #2563eb !important; }
.text-blue-700 { color: #1d4ed8 !important; }
.text-blue-800 { color: #1e40af !important; }
.text-emerald-500 { color: #10b981 !important; }
.text-emerald-600 { color: #059669 !important; }
.text-emerald-700 { color: #047857 !important; }
.text-indigo-500 { color: #6366f1 !important; }
.text-amber-800 { color: #92400e !important; }
.text-purple-800 { color: #6b21a8 !important; }
.text-white { color: #ffffff !important; }

/* Borders & Rounding */
.border { border: 1px solid #cbd5e1 !important; }
.border-transparent { border-color: transparent !important; }
.border-slate-100 { border-color: #f1f5f9 !important; }
.border-slate-200 { border-color: #cbd5e1 !important; }
.border-red-200 { border-color: #fca5a5 !important; }
.border-amber-200 { border-color: #fcd34d !important; }
.border-emerald-200 { border-color: #a7f3d0 !important; }
.border-blue-200 { border-color: #bfdbfe !important; }
.border-purple-200 { border-color: #e9d5ff !important; }

.rounded { border-radius: 4px !important; }
.rounded-lg { border-radius: 8px !important; }
.rounded-xl { border-radius: 12px !important; }
.rounded-2xl { border-radius: 16px !important; }
.rounded-full { border-radius: 9999px !important; }
.overflow-hidden { overflow: hidden !important; }

/* Transitions & Shadow */
.shadow-sm { box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important; }
.shadow-2xl { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important; }
.transition-colors { transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out !important; }
.transition-all { transition: all 0.15s ease-in-out !important; }

/* Note editor styles */
.oi-note-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.oi-textarea {
  width: 100%;
  min-width: 140px;
  font-size: 16px;
  padding: 6px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  resize: vertical;
  outline: none;
  transition: all 0.2s ease-in-out;
  background-color: #ffffff;
  color: #334155;
  line-height: 1.4;
}
.oi-textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
  background-color: #f8fafc;
}
.oi-note-label {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
  font-weight: 600;
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.declaration-image-preview {
  width: 64px;
  height: 64px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  background: #ffffff;
}

.declaration-image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.declaration-status-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  padding: 6px 10px;
  border-radius: 9999px;
  background-color: #f8fafc;
  border: 1px solid currentColor;
  line-height: 1.3;
  white-space: nowrap !important;
}

.invoice-check-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 9px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.invoice-check-item:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.invoice-check-item.is-checked {
  border-color: #93c5fd;
  background: #eff6ff;
}

.invoice-check-item.is-disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.invoice-check-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.invoice-check-box {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  border: 1px solid #94a3b8;
  background: #ffffff;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 16px;
  transition: all 0.15s ease;
}

.invoice-check-box i {
  font-size: 9px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.invoice-check-item.is-checked .invoice-check-box {
  border-color: #2563eb;
  background: #2563eb;
}

.invoice-check-item.is-checked .invoice-check-box i {
  opacity: 1;
}

.invoice-check-label {
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  white-space: normal;
}

.history-log-item {
  min-height: 46px;
}

.order-summary-row td {
  background: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  border-top: 1px solid #e2e8f0 !important;
  overflow: visible !important;
}

.order-summary-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  color: #64748b;
  font-size: 17px;
  line-height: 1.5;
}

.order-summary-text {
  white-space: nowrap;
}

.order-summary-link,
.order-code-link {
  cursor: pointer;
  text-decoration: none;
}

.order-summary-link:hover,
.order-code-link:hover {
  text-decoration: underline;
}

.order-summary-value--paid {
  color: #047857;
}

.order-summary-value--remain {
  color: #b91c1c;
}

.order-extra-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-extra-row {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding-top: 4px;
}

.order-extra-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 700;
  text-transform: uppercase;
}

.order-extra-value {
  font-size: 15px;
  color: #0f172a;
  font-weight: 600;
  line-height: 1.35;
}

/* Sub table styling */
.sub-declaration-table, .sub-package-table {
  border-collapse: collapse;
  width: 100%;
}
.sub-declaration-table th, .sub-declaration-table td,
.sub-package-table th, .sub-package-table td {
  border: 1px solid rgba(0,0,0,0.1) !important;
  vertical-align: middle !important; /* Align inner cell contents to the middle */
  padding: 8px !important;
}
.sub-declaration-table th, .sub-package-table th {
  font-weight: 600;
}
.sub-declaration-table tr.bg-slate-100 td,
.sub-declaration-table tr.bg-slate-100 td span,
.sub-declaration-table tr.bg-slate-100 td sup {
  font-weight: bold !important; /* Make summary row bold */
}

.sub-table-header {
  background-color: #2c6fad !important;
  color: #ffffff !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.sub-table-header th {
  height: 48px;
}

/* Custom CSS layout constraints to align header and body cells perfectly */
.col-seq {
  width: 35px !important;
  min-width: 35px !important;
  max-width: 35px !important;
}
.col-select {
  width: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
}
.col-order {
  width: 135px !important;
  min-width: 135px !important;
  max-width: 135px !important;
}
.col-details {
  min-width: 1185px !important;
}
.col-print {
  width: 135px !important;
  min-width: 135px !important;
  max-width: 135px !important;
}
.col-invoice {
  width: 180px !important;
  min-width: 180px !important;
  max-width: 180px !important;
}
.col-history {
  width: 140px !important;
  min-width: 140px !important;
  max-width: 140px !important;
}
.col-declaration-status {
  width: 160px !important;
  min-width: 160px !important;
  max-width: 160px !important;
}

.staff-selects-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.active-tab {
  border-color: #cbd5e1 !important;
}

.print-modal-inner {
  background-color: #ffffff !important;
  border-radius: 16px !important;
  border: 1px solid #f1f5f9 !important;
  padding: 24px !important;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.body-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.buttons-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.btn-print, .btn-pdf {
  border: none;
  cursor: pointer;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.order-select-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.declaration-filter-select {
  min-width: 168px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background-color: #ffffff;
  outline: none;
}

.declaration-filter-select:focus {
  border-color: #94a3b8;
}

/* Custom styling for standard buttons to match mockup */
.print-buttons-container button, .btn-detail-order {
  border-collapse: collapse;
  outline: none;
  cursor: pointer;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.main-declaration-table >>> table {
  table-layout: fixed !important;
  border-collapse: collapse !important;
}

/* Remove default Vuetify borders on the main list table cells specifically to prevent nested tables from inheriting */
.main-declaration-table >>> tbody > tr > td.col-seq,
.main-declaration-table >>> tbody > tr > td.col-select,
.main-declaration-table >>> tbody > tr > td.col-order,
.main-declaration-table >>> tbody > tr > td.col-details,
.main-declaration-table >>> tbody > tr > td.col-print,
.main-declaration-table >>> tbody > tr > td.col-invoice,
.main-declaration-table >>> tbody > tr > td.col-history,
.main-declaration-table >>> tbody > tr > td.col-declaration-status {
  border-right: none !important;
  border-left: none !important;
  border-bottom: 1px solid #e2e8f0 !important; /* border-slate-200 */
  padding: 12px 4px !important;
  vertical-align: top !important; /* align-top */
}
.main-declaration-table >>> tbody > tr:last-child > td.col-seq,
.main-declaration-table >>> tbody > tr:last-child > td.col-select,
.main-declaration-table >>> tbody > tr:last-child > td.col-order,
.main-declaration-table >>> tbody > tr:last-child > td.col-details,
.main-declaration-table >>> tbody > tr:last-child > td.col-print,
.main-declaration-table >>> tbody > tr:last-child > td.col-invoice,
.main-declaration-table >>> tbody > tr:last-child > td.col-history,
.main-declaration-table >>> tbody > tr:last-child > td.col-declaration-status {
  border-bottom: none !important;
}
.main-declaration-table >>> tbody > tr:not(.sub-table-row):not(.sub-table-header):hover {
    background-color: #ffffff !important;
}
.main-declaration-table >>> thead > tr > th.col-seq,
.main-declaration-table >>> thead > tr > th.col-select,
.main-declaration-table >>> thead > tr > th.col-order,
.main-declaration-table >>> thead > tr > th.col-details,
.main-declaration-table >>> thead > tr > th.col-print,
.main-declaration-table >>> thead > tr > th.col-invoice,
.main-declaration-table >>> thead > tr > th.col-history,
.main-declaration-table >>> thead > tr > th.col-declaration-status {
  border-right: none !important;
  border-left: none !important;
  border-bottom: 1px solid #cbd5e1 !important; /* border-b border-slate-200 */
  background-color: #f1f5f9 !important; /* bg-slate-100 */
  color: #475569 !important; /* text-slate-600 */
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 12px 4px !important;
}

.main-declaration-table >>> thead > tr > th.col-seq span,
.main-declaration-table >>> thead > tr > th.col-select span,
.main-declaration-table >>> thead > tr > th.col-order span,
.main-declaration-table >>> thead > tr > th.col-details span,
.main-declaration-table >>> thead > tr > th.col-print span,
.main-declaration-table >>> thead > tr > th.col-invoice span,
.main-declaration-table >>> thead > tr > th.col-history span,
.main-declaration-table >>> thead > tr > th.col-declaration-status span {
    color: #475569 !important; /* text-slate-600 */
    font-size: 16px !important;
    font-weight: 600 !important;
    text-transform: none !important; /* Disable uppercase casing */
}

/* Prevent wrapping inside buttons, badges, and history logs */
.print-buttons-container button,
.invoice-status-container button,
.history-logs-container span {
  white-space: nowrap !important;
}

/* Reduce cell horizontal paddings for action and history columns to maximize usable space */
.main-declaration-table >>> td.col-print,
.main-declaration-table >>> td.col-invoice,
.main-declaration-table >>> td.col-history,
.main-declaration-table >>> td.col-declaration-status {
  padding: 16px 6px !important;
}

/* Outer layout column sizing configuration */
.main-declaration-table >>> th.col-seq, .main-declaration-table >>> td.col-seq {
  width: 35px !important;
  min-width: 35px !important;
  max-width: 35px !important;
}
.main-declaration-table >>> th.col-select, .main-declaration-table >>> td.col-select {
  width: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
}
.main-declaration-table >>> th.col-order, .main-declaration-table >>> td.col-order {
  width: 135px !important;
  min-width: 135px !important;
  max-width: 135px !important;
}
.main-declaration-table >>> th.col-details, .main-declaration-table >>> td.col-details {
  min-width: 1185px !important;
}
.main-declaration-table >>> th.col-print, .main-declaration-table >>> td.col-print {
  width: 135px !important;
  min-width: 135px !important;
  max-width: 135px !important;
}
.main-declaration-table >>> th.col-invoice, .main-declaration-table >>> td.col-invoice {
  width: 180px !important;
  min-width: 180px !important;
  max-width: 180px !important;
}
.main-declaration-table >>> th.col-history, .main-declaration-table >>> td.col-history {
  width: 140px !important;
  min-width: 140px !important;
  max-width: 140px !important;
}
.main-declaration-table >>> th.col-declaration-status, .main-declaration-table >>> td.col-declaration-status {
  width: 160px !important;
  min-width: 160px !important;
  max-width: 160px !important;
}

.space-y-1 > * + * {
  margin-top: 4px !important;
}
.space-y-2 > * + * {
  margin-top: 8px !important;
}
.container.grid-list-xl .layout .flex {
    padding: 2px !important;
}

.action-btn:disabled {
  background-color: #f1f5f9 !important; /* bg-slate-100 */
  color: #94a3b8 !important; /* text-slate-400 */
  border-color: #e2e8f0 !important; /* border-slate-200 */
  cursor: not-allowed !important;
  opacity: 0.7;
}

.action-btn:disabled i {
  color: #94a3b8 !important; /* text-slate-400 */
}

.table-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.table-image-thumb {
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #d7d7d7;
  cursor: pointer;
}
.justify-center {
  justify-content: center;
}

.hs-cell-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.importer-select {
  width: 100%;
  max-width: 130px;
  font-size: 11px;
  padding: 3px 16px 3px 6px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  outline: none;
  background-color: #ffffff;
  color: #334155;
  height: 26px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 4px center;
  background-size: 10px;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.importer-select:focus {
  border-color: #3b82f6;
}
</style>
